module.exports = __webpack_public_path__ + "img/3.387bd44e.jpg";